import { Route } from "react-router-dom";
import AuthorizedRoute from "../../components/routing/authorized-route";
import { Roles } from "../../components/routing/utils";

import Alerts from "./page.highorder";

const ProtectedManageAlerts = () => (
  <AuthorizedRoute requiredRoles={[Roles.ADMIN]} component={Alerts} />
);

const clientsRoute = (
  <Route path="/manage-alerts" element={<ProtectedManageAlerts />} />
);

export default clientsRoute;
